import React from 'react'
import classNames from 'classnames'

import FieldWrapper from '../FieldWrapper'

import style from './style.scss'

/*
 * This component needs to be nested within a parent component to control state
 * When the parent component is rendering the child components it should
 * check if the current controlled state is the same as the value for
 * each instance of the component, setting the checked property with that
 * boolean result.
 *
 * The printed label uses props.children to allow for the text to be
 * formatted with bold or italic tags, rather than just plain text.
 */
type Props = {
  checked: boolean
  children: React.ReactNode
  className?: string
  errorText?: string
  handleOptionChange: (arg0: string) => void
  inputId: string
  isInvalid?: boolean
  isRequired?: boolean
  name?: string
  value: string
}

Radio.defaultProps = {
  className: '',
  errorText: '',
  isInvalid: false,
  isRequired: false,
  name: '',
}

function Radio(props: Props) {
  const {
    checked,
    children,
    className,
    errorText,
    handleOptionChange,
    inputId,
    isInvalid,
    isRequired,
    name,
    value,
  } = props
  return (
    <FieldWrapper className={classNames(style.wrapper, className)}>
      <input
        checked={checked}
        className={style.checkbox}
        id={inputId}
        name={name}
        required={isRequired}
        type='radio'
        value={value}
        onChange={(evt) => {
          errorText && evt.currentTarget.setCustomValidity('')
          return handleOptionChange(evt.currentTarget.value)
        }}
        onInvalid={
          errorText
            ? (evt) => {
                isInvalid
                  ? evt.currentTarget.setCustomValidity(errorText)
                  : evt.currentTarget.setCustomValidity('')
              }
            : undefined
        }
      />
      <span className={style.checkmark} />
      <label className={style.label} htmlFor={inputId}>
        {children}
      </label>
    </FieldWrapper>
  )
}

export default Radio
